/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function ArrowCurveDownRight({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" fillRule="evenodd" d="M3 2.4a.6.6 0 0 1 .6.6v4A2.4 2.4 0 0 0 6 9.4h5.552L9.576 7.424a.6.6 0 1 1 .848-.848l3 3a.6.6 0 0 1 0 .848l-3 3a.6.6 0 0 1-.848-.848l1.976-1.976H6A3.6 3.6 0 0 1 2.4 7V3a.6.6 0 0 1 .6-.6" clipRule="evenodd" /></svg>;
}
;